import Preact from 'preact';

var FormStructure = {
    fields: {
        headerLabel: {
            validations: []
        },
        FirstName: {
            validations: [{ type: 'required', message: 'Please fill in required field.' }
        ]
        },
        LastName: {
            validations: [{ type: 'required', message: 'Please fill in required field.' }
        ]
        },
        Email: {
            validations: [{ type: 'required', message: 'Please fill in required field.' },
                { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email.' }
            ]
        },
        TelNumber: {
            validations: [
                { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number.' }
            ]
        },
        ClientName: {
            validations: [{ type: 'required', message: 'Please fill in required field.' }
        ]
        },
        Theme: {
            validations: []
        },
        Category: {
            validations: []
        },
        PlannedGuestCount: {
            validations: [
                { type: 'regex', pattern: '^[0-9]*$', message: 'Please provide in numbers only.' }
            ]
        },
        EventDate: {
            validations: [
                { type: 'dateinfuture', message: 'Event date must be in the future.' }
            ]
        },
        City: {
            validations: []
        },
        State: {
            validations: []
        },
        Notes: {
            validations: []
        }
    },
    layout: {
        rows: 
          [
            {
                fields: [
                  {
                    type: 'label',
                    size: 'Medium',
                    label: 'Request for Proposal',
                    mapping: 'headerLabel',
                    customClasses: ['header']
                  }
                ]
              },
            {
                fields: [{
                    type: 'text',
                    size: 'Medium',
                    label: 'First Name*',
                    mapping: 'FirstName'
                }]
            },
            {
                fields: [{
                    type: 'text',
                    size: 'Medium',
                    label: 'Last Name*',
                    mapping: 'LastName'
                }]
            },
            {
                fields: [{
                    type: 'text',
                    size: 'Medium',
                    label: 'Email*',
                    mapping: 'Email'
                }]
            },
            {
                fields: [{
                    type: 'text',
                    size: 'Medium',
                    label: 'Contact Number',
                    mapping: 'TelNumber'
                }]
            },
            {
                fields: [{
                    type: 'text',
                    size: 'Medium',
                    label: 'Company*',
                    mapping: 'ClientName'
                }]
            },
            {
                fields: [
                  {
                    type: 'label',
                    size: 'Medium',
                    label: 'Event Information',
                    mapping: 'headerLabel',
                    customClasses: ['header']
                  }
                ]
              },
            {
                fields: [
                    {
                    type: 'multiple-choice',
                    size: 'Medium',
                    label: 'Select Event Theme',
                    options: [
                        {label: 'Company Milestone Celebration' , value: 'Company Milestone Celebration'},
                        {label: 'Dinner / Party /Reception' , value: 'Dinner / Party /Reception'},
                        {label: 'Employee Event' , value: 'Employee Event'},
                        {label: 'Grand Opening' , value: 'Grand Opening'},
                        {label: 'Marketing Event' , value: 'Marketing Event'},
                        {label: 'Meeting' , value: 'Meeting'},
                        {label: 'Multi-Day Event' , value: 'Multi-Day Event'},
                    ],
                    mapping: 'Theme'
                }
            ]
            },
            {
                fields: [{
                    type: 'multiple-choice',
                    size: 'Medium',
                    label: 'Select Event Category',
                    options:[
                        {label: 'In Person' , value: 'In Person'},
                        {label: 'Hybrid' , value: 'Hybrid'},
                        {label: 'Virtual' , value: 'Virtual'},
                    ],
                    mapping: 'Category'
                }]
            },
            {
                fields: [{
                    type: 'text',
                    size: 'Medium',
                    label: 'How Many People?',
                    mapping: 'PlannedGuestCount'
                }]
            },
            {
                fields: [{
                    type: 'date-picker-nofill',
                    size: 'Medium',
                    label: 'Date of Event',
                    mapping: 'EventDate'
                }]
            },
            {
                fields: [{
                    type: 'text',
                    size: 'Medium',
                    label: 'City of Event',
                    mapping: 'City'
                }]
            },
            {
                fields: [{
                    type: 'multiple-choice',
                    size: 'Medium',
                    label: 'State of Event',
                    options: [
                        { label: 'AL', value: 'AL' },
                        { label: 'AK', value: 'AK' },
                        { label: 'AZ', value: 'AZ' },
                        { label: 'AR', value: 'AR' },
                        { label: 'CA', value: 'CA' },
                        { label: 'CO', value: 'CO' },
                        { label: 'CT', value: 'CT' },
                        { label: 'DE', value: 'DE' },
                        { label: 'DC', value: 'DC' },
                        { label: 'FL', value: 'FL' },
                        { label: 'GA', value: 'GA' },
                        { label: 'HI', value: 'HI' },
                        { label: 'ID', value: 'ID' },
                        { label: 'IL', value: 'IL' },
                        { label: 'IN', value: 'IN' },
                        { label: 'IA', value: 'IA' },
                        { label: 'KS', value: 'KS' },
                        { label: 'KY', value: 'KY' },
                        { label: 'LA', value: 'LA' },
                        { label: 'ME', value: 'ME' },
                        { label: 'MD', value: 'MD' },
                        { label: 'MA', value: 'MA' },
                        { label: 'MI', value: 'MI' },
                        { label: 'MN', value: 'MN' },
                        { label: 'MS', value: 'MS' },
                        { label: 'MO', value: 'MO' },
                        { label: 'MT', value: 'MT' },
                        { label: 'NE', value: 'NE' },
                        { label: 'NV', value: 'NV' },
                        { label: 'NH', value: 'NH' },
                        { label: 'NJ', value: 'NJ' },
                        { label: 'NM', value: 'NM' },
                        { label: 'NY', value: 'NY' },
                        { label: 'NC', value: 'NC' },
                        { label: 'ND', value: 'ND' },
                        { label: 'OH', value: 'OH' },
                        { label: 'OK', value: 'OK' },
                        { label: 'OR', value: 'OR' },
                        { label: 'PA', value: 'PA' },
                        { label: 'RI', value: 'RI' },
                        { label: 'SC', value: 'SC' },
                        { label: 'SD', value: 'SD' },
                        { label: 'TN', value: 'TN' },
                        { label: 'TX', value: 'TX' },
                        { label: 'UT', value: 'UT' },
                        { label: 'VT', value: 'VT' },
                        { label: 'VA', value: 'VA' },
                        { label: 'WA', value: 'WA' },
                        { label: 'WV', value: 'WV' },
                        { label: 'WI', value: 'WI' },
                        { label: 'WY', value: 'WY' }
                    ],
                    mapping: 'State'
                }]
            },
            {
                fields: [{
                    type: 'text-area',
                    size: 'Medium',
                    label: 'Tell Us More',
                    mapping: 'Notes'
                }]
            },
            {
                fields: [{
                    type: 'submit',
                    size: 'XLarge',
                    label: 'Submit'
                }]
            }
        ]
    },
    info: {
        title: 'Event Group Houston Contact Form',
        formId: '733',
        clientKey: 'D9E764CB-6776-42CF-8211-E7FC82B099C4',
        appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
        redirectUrl: '',
        submissionText: 'Thank you for your submission. Someone will be contacting you soon',
        apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
    }
};


export default FormStructure;


// WEBPACK FOOTER //
// C:/Users/adrienn.bonnyai/Web-Inquiry/inquiry-renderer/client_forms/eventgrouphouston/form_structure.js